"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable react/require-default-props */
var react_1 = __importStar(require("react"));
var react_2 = require("@fluentui/react");
var awesome_phonenumber_1 = __importDefault(require("awesome-phonenumber"));
require("./MobilePhoneField.scss");
var CustomDropdown_1 = __importDefault(require("./CustomDropdown"));
var CustomTextField_1 = require("./CustomTextField");
var dropdownStyles = {
    dropdown: { width: 100 },
};
var options = awesome_phonenumber_1.default.getSupportedCallingCodes().map(function (callingCode) {
    var countrycode = awesome_phonenumber_1.default.getRegionCodeForCountryCode(Number.parseInt(callingCode, 10));
    return { key: callingCode, text: "+" + callingCode + " " + countrycode };
});
exports.MobilePhoneField = function (props) {
    var validationFunc = props.validationFunc, onValidationChange = props.onValidationChange, errorMessageFromProps = props.errorMessage, phone = props.phone, label = props.label, readOnly = props.readOnly, required = props.required, countryCodes = props.countryCodes;
    var _a = react_1.useState(), errorMessage = _a[0], setErrorMessage = _a[1];
    var _b = react_1.useState(undefined), isValid = _b[0], setIsValid = _b[1];
    var onChangeValue = react_1.useCallback(function (val) {
        var newIsValid = true;
        var previousError = errorMessage;
        if (errorMessageFromProps) {
            if (previousError !== errorMessageFromProps) {
                setErrorMessage(errorMessageFromProps);
            }
            newIsValid = false;
        }
        else if (validationFunc) {
            var error = validationFunc(val !== null && val !== void 0 ? val : '');
            if (previousError !== error) {
                setErrorMessage(error);
            }
            if (error) {
                newIsValid = false;
            }
        }
        if (newIsValid !== isValid) {
            setIsValid(newIsValid);
            if (newIsValid) {
                if (previousError) {
                    setErrorMessage(undefined);
                }
            }
            if (onValidationChange) {
                onValidationChange(newIsValid);
            }
        }
    }, [
        errorMessageFromProps,
        errorMessage,
        isValid,
        onValidationChange,
        validationFunc,
    ]);
    var getNumberPart = function (number) {
        if (number) {
            var pn = new awesome_phonenumber_1.default(number);
            if (pn.isValid()) {
                return (pn === null || pn === void 0 ? void 0 : pn.getNumber()) ? pn.getNumber().substring(pn.getCountryCode().toString().length + 1)
                    : number;
            }
            return number;
        }
        return '';
    };
    var getCountryPart = function (number) {
        if (number) {
            var pn = new awesome_phonenumber_1.default(number);
            if (pn.isValid()) {
                return pn.getCountryCode().toString();
            }
        }
        return '';
    };
    var _c = react_1.useState(getCountryPart(phone)), countryPart = _c[0], setCountryPart = _c[1];
    var _d = react_1.useState(getNumberPart(phone)), numberPart = _d[0], setNumberPart = _d[1];
    react_1.useEffect(function () {
        var pn = new awesome_phonenumber_1.default(phone !== null && phone !== void 0 ? phone : '');
        if (pn.isValid()) {
            setNumberPart(getNumberPart(phone));
            setCountryPart(getCountryPart(phone));
        }
        onChangeValue(phone);
    }, [phone, onChangeValue]);
    var onChangeCountryCode = function (event, option) {
        if (option === null || option === void 0 ? void 0 : option.key) {
            var newPhone = "+" + (option === null || option === void 0 ? void 0 : option.key) + numberPart;
            setCountryPart(option.key.toString());
            onChangeValue(newPhone);
            if (props.onChangePhone) {
                props.onChangePhone(newPhone);
            }
        }
    };
    var onChangePhonePart = function (event, newValue) {
        var newPhone = '';
        var pn = new awesome_phonenumber_1.default(newValue !== null && newValue !== void 0 ? newValue : '');
        if (pn.isValid()) {
            var ctyPart = getCountryPart(newValue);
            if (countryPart !== ctyPart) {
                setCountryPart(ctyPart);
            }
            var numPart = getNumberPart(newValue);
            if (numberPart !== numPart) {
                setNumberPart(numPart);
            }
            newPhone = "+" + ctyPart + numPart;
        }
        else {
            setNumberPart(newValue !== null && newValue !== void 0 ? newValue : '');
            if (newValue) {
                newPhone = "+" + countryPart + newValue;
            }
        }
        onChangeValue(newPhone);
        if (props.onChangePhone) {
            props.onChangePhone(newPhone);
        }
    };
    return (react_1.default.createElement("div", { className: "eta-vertialFlexDiv" },
        label && (react_1.default.createElement(react_2.Label, null, label)),
        react_1.default.createElement("div", { className: "eta-mobilePhoneFieldInner" },
            react_1.default.createElement(CustomDropdown_1.default, { options: countryCodes !== null && countryCodes !== void 0 ? countryCodes : options, readOnly: readOnly, styles: dropdownStyles, required: required, selectedKey: countryPart, onChange: onChangeCountryCode }),
            react_1.default.createElement("div", { className: "space10" }),
            react_1.default.createElement(CustomTextField_1.TextField, { readOnly: readOnly, value: numberPart, required: required, isManualErrorMessageBlock: true, errorMessage: errorMessage, containerClassName: "grow", onChange: onChangePhonePart }))));
};
//# sourceMappingURL=MobilePhoneField.js.map